import { render } from "./color-input.vue?vue&type=template&id=5c4b45cf"
import script from "./color-input.vue?vue&type=script&lang=js"
export * from "./color-input.vue?vue&type=script&lang=js"

import "./color-input.vue?vue&type=style&index=0&id=5c4b45cf&lang=scss"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__